import React from "react";
import { Show, SimpleShowLayout, NumberField, TextField, ReferenceField, useTranslate } from "react-admin";
import { ActionsWithBackButton } from "components/actionbars/ActionsWithBackButton";
import { DateTimeField } from "components/fields/DateFormatField";
import { SelectEnumField } from "components/fields/SelectEnumField";
import { CopyField } from "components/fields/CopyField";
import { StorageContextType } from "entities/StorageContextType";
import { StorageEntityType } from "entities/StorageEntityType";
import { StorageTransactionDirection } from "entities/StorageTransactionDirection";
import { plainNumber } from "utils/constants";

export const StorageTransactionsShow = (props) => {
	const translate = useTranslate();
	const t = (source) => translate(`resources.storage-transactions.fields.${source}`);

	return (
		<Show actions={<ActionsWithBackButton />} {...props}>
			<SimpleShowLayout>
				<NumberField source="id" {...plainNumber} />
				<SelectEnumField
					source="direction"
					label={t("direction")}
					enumObj={StorageTransactionDirection}
					enumName="storage_transaction_direction"
				/>
				<NumberField source="storage_entity_id" {...plainNumber} />
				<NumberField source="storage_place_id" {...plainNumber} />
				<NumberField source="storage_context_id" {...plainNumber} />
				<DateTimeField source="timestamp" />
				<DateTimeField source="planned_timestamp" />
				<DateTimeField source="modified_at" />
				<NumberField source="modified_by" emptyText="System" {...plainNumber} />

				<NumberField source="storage_context.id" label={t("storage_context_id")} {...plainNumber} />
				<SelectEnumField
					source="storage_context.type"
					label={t("storage_context_type")}
					enumObj={StorageContextType}
					enumName="storage_context_type"
				/>
				<ReferenceField
					source="storage_context.terminal_id"
					reference="terminal"
					label={t("storage_context_terminal")}
					link={false}
				>
					<TextField source="name" />
				</ReferenceField>
				<NumberField source="storage_context.order_id" label={t("storage_context_order_id")} {...plainNumber} />
				<CopyField
					source="storage_context.order.reference"
					label={t("storage_context_order_reference")}
					copyByIcon
				/>
				<NumberField
					source="storage_context.order_deviation_id"
					label={t("storage_context_order_deviation_id")}
					{...plainNumber}
				/>
				<NumberField source="storage_context.task_id" label={t("storage_context_task_id")} {...plainNumber} />

				<NumberField source="storage_place.id" label={t("storage_place_id")} {...plainNumber} />
				<CopyField
					source="storage_place.address"
					label={t("storage_place_address")}
					copyByIcon
				/>
				<TextField source="storage_place.rack_address" label={t("storage_place_rack_address")} />

				<NumberField source="storage_entity.id" label={t("storage_entity_id")} {...plainNumber} />
				<SelectEnumField
					source="storage_entity.type"
					label={t("storage_entity_type")}
					enumObj={StorageEntityType}
					enumName="storage_entity_type"
				/>
				<NumberField
					source="storage_entity.pallet_id"
					label={t("storage_entity_pallet_id")}
					{...plainNumber}
				/>
				<CopyField
					source="storage_entity.pallet.sscc"
					label={t("storage_entity_pallet_sscc")}
					copyByIcon
				/>
				<CopyField
					source="storage_entity.pallet.ceel_number"
					label={t("storage_entity_pallet_ceel_number")}
					copyByIcon
				/>

				<TextField source="user.full_name" label={t("user_full_name")} emptyText="System" />
			</SimpleShowLayout>
		</Show>
	);
};
